import React, { useState, useEffect } from "react";
import "./RequestQuote.css";
import arrowIcon from "../../assets/RequestQuote/arrow-right.svg";
import API_BASE_URL from "../../config";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { AnimatedButton } from "../common/AnimatedButton";

const RequestQuote = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    website: "", // ← honeypot field
  });

  const location = useLocation();
  const variant = location.pathname === "/contact" ? "contact" : "";

  const color = props?.styles?.color || "#ffffff";
  const placeholderColor = props?.styles?.placeholderColor || "#ffffff";

  const [status, setStatus] = useState(""); // Success/error message
  const [loading, setLoading] = useState(false); // Loading state

  // Clear status message after 5 seconds
  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => setStatus(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Submitting form data:", formData);

    // Basic client-side validation
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim()
    ) {
      setStatus("Please fill out all fields.");
      return;
    }

    // Email format validation
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setStatus("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("message", formData.message);

      for (let [key, value] of data.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${API_BASE_URL}/contact`, {
        method: "POST",
        body: data, // Let browser set Content-Type for FormData
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Something went wrong");
      }
      console.log("Server response:", result);
      toast.success("We'll connect with you ASAP!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setStatus(result.message || "Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" }); // Reset form
    } catch (error) {
      toast.error("Something went wrong! ty again later.  ", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      console.error("Send message error:", error);
      setStatus("Failed to send message: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="quote-section"
      style={{
        backgroundColor: props?.styles?.bgColor || "#111111",
        color: color,
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <div className="quote-container">
        <div className="quote-header">
          <h2>
            <span className="emoji">👋</span> Let's Talk!
          </h2>
          <div className="side-text">
            <p style={{ color: color }}>
              Only a friendly crew eager to assist you with creating something
              awesome.
            </p>
          </div>
        </div>

        <form className="quote-form" onSubmit={handleSubmit} id="quoteForm">
          <input
            type="text"
            name="website"
            value={formData.website}
            onChange={handleChange}
            autoComplete="off"
            style={{ display: "none", color: color }}
          />

          <div className="quote-grid">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={loading}
              style={{ color: color }}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
              style={{ color: color }}
            />
          </div>

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
            disabled={loading}
            style={{ color: color }}
          />

          <textarea
            name="message"
            placeholder="What's on your mind? A few lines about what you're looking for—we'd love to know!"
            value={formData.message}
            onChange={handleChange}
            required
            disabled={loading}
            style={{ color: color }}
          />

          {/* <button
            type="submit"
            className={`quote-submit animated-submit-btn${variant}`}
            disabled={loading}
            style={{ color: color }}
          >
            <span className="btn-text">
              {loading ? "Sending..." : "Submit"}
            </span>
            <span className="btn-circle">
              <img src={arrowIcon} alt="arrow" className="arrow-icon" />
            </span>
          </button> */}
          <AnimatedButton
            label={loading ? "Sending..." : "Submit"}
            link=""
            onClick={() => document.getElementById("quoteForm").requestSubmit()}
          />
        </form>

        {/* Status message with aria-live for accessibility */}
        {/* {status && (
          <p className="form-status" aria-live="polite" role="alert">
            {status}
          </p>
        )} */}
      </div>
    </section>
  );
};

export default RequestQuote;
